module.exports = "<span *ngIf=\"isComponentImage()\" class=\"{{icon.componentImage.style}}\">\n    <i #content></i>\n</span>\n<i *ngIf=\"!isComponentImage()\"\n   class=\"{{icon.image}}\">\n</i>"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/modules/space/menu/menu.icon.template.html
// module id = 886
// module chunks = 0